import v from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
import s from "../../../rc-util/es/Dom/canUseDom.mjs";
function c(n, t) {
  var e = {};
  return e[n.toLowerCase()] = t.toLowerCase(), e["Webkit".concat(n)] = "webkit".concat(t), e["Moz".concat(n)] = "moz".concat(t), e["ms".concat(n)] = "MS".concat(t), e["O".concat(n)] = "o".concat(t.toLowerCase()), e;
}
function p(n, t) {
  var e = {
    animationend: c("Animation", "AnimationEnd"),
    transitionend: c("Transition", "TransitionEnd")
  };
  return n && ("AnimationEvent" in t || delete e.animationend.animation, "TransitionEvent" in t || delete e.transitionend.transition), e;
}
var l = p(s(), typeof window < "u" ? window : {}), d = {};
if (s()) {
  var w = document.createElement("div");
  d = w.style;
}
var a = {};
function m(n) {
  if (a[n])
    return a[n];
  var t = l[n];
  if (t)
    for (var e = Object.keys(t), o = e.length, r = 0; r < o; r += 1) {
      var i = e[r];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in d)
        return a[n] = t[i], a[n];
    }
  return "";
}
var u = m("animationend"), f = m("transitionend"), g = !!(u && f), T = u || "animationend", y = f || "transitionend";
function k(n, t) {
  if (!n)
    return null;
  if (v(n) === "object") {
    var e = t.replace(/-\w/g, function(o) {
      return o[1].toUpperCase();
    });
    return n[e];
  }
  return "".concat(n, "-").concat(t);
}
export {
  T as animationEndName,
  k as getTransitionName,
  m as getVendorPrefixedEventName,
  p as getVendorPrefixes,
  g as supportTransition,
  y as transitionEndName
};
//# sourceMappingURL=motion.mjs.map
